// extracted by mini-css-extract-plugin
export default {"tooltip":"Text__tooltip-xelPg"};